import * as React from "react";
const TikTokSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 3a3 3 0 0 0 3 3v2a4.978 4.978 0 0 1-3-1v4a4 4 0 1 1-3-3.874v2.141A2 2 0 0 0 6 11a2 2 0 1 0 4 0V3h2Z" }));
TikTokSmall.displayName = "TikTokSmall";
var TikTokSmall_default = TikTokSmall;
export {
  TikTokSmall_default as default
};
